import { broadcastLogout, initialState, userDataStore } from './store';
import { UserDataState, UserDataV2 } from './types';

import { getOnlyUserDetails, getUserAttributeDetails } from '../../services';
import { hasSession } from 'src/utils/helpers';

export const setUserDataLoading = () => {
  userDataStore.setState({
    isUserDataLoading: true,
    isUserDataError: false,
    userDataError: null,
  });
};

export const setUserData = (
  userData: UserDataV2,
  isMaskedDataStored: boolean,
  userAttributes: UserDataState['userAttributes'] = null
) => {
  userDataStore.setState({
    userData,
    userAttributes,
    isUserDataLoading: false,
    isUserDataError: false,
    userDataError: null,
    isMaskedDataStored,
    lastApiTriggerTimeStamp: new Date().getTime(),
  });
};

export const setUserDataError = (error: unknown) => {
  userDataStore.setState({
    isUserDataLoading: false,
    isUserDataError: true,
    userDataError: error,
    lastApiTriggerTimeStamp: new Date().getTime(),
  });
};

export const updateUserDataStore = async () => {
  const isUser2FaLoggedIn = hasSession(true);
  const isUser1FaLoggedIn = hasSession();
  
  if (isUser2FaLoggedIn) return updateUserDataStoreWith2FA();

  if (isUser1FaLoggedIn) return updateUserDataStoreWith1FA();

  return;
};

//update user data store with 1fa session which give masked user details in response
export const updateUserDataStoreWith1FA: () => void = async () => {
  if (!userDataStore.getState().isUserDataLoading) {
    try {
      setUserDataLoading();
      const userDataRes = await getOnlyUserDetails();
      const isMaskedData = true;

      setUserData(userDataRes.data, isMaskedData);
    } catch (error: unknown) {
      setUserDataError(error);
    }
  }
};

//update user data store with 2fa session which give unmasked user details in response
export const updateUserDataStoreWith2FA: () => void = async () => {
  if (!userDataStore.getState().isUserDataLoading) {
    try {
      setUserDataLoading();
      const userDataRes = await getUserAttributeDetails();
      const { user, attributes } = userDataRes?.data?.data || {};
      const isMaskedData = false;

      setUserData(user, isMaskedData, attributes);
    } catch (error: unknown) {
      setUserDataError(error);
    }
  }
};

export const clearUserDataStore: () => void = () => {
  // Broadcast logout to all other tabs before clearing
  broadcastLogout();

  userDataStore.setState(initialState);

  // Clear persisted data from local storage
  userDataStore.persist.clearStorage();
};
